import BoxWrapper from "./box-wrapper";
import CartBookingForm from "./cart-booking-form";

const PickUpSummary = ({
  tempCartToSubmit,
  setTempCartToSubmit,
  tempBookingDate,
  setTempBookingDate,
}) => {
  return (
    <>
      <BoxWrapper
        isConfirmPhase
        tempCartToSubmit={tempCartToSubmit}
        setTempCartToSubmit={setTempCartToSubmit}
        tempBookingDate={tempBookingDate}
      />
      <CartBookingForm
        tempCartToSubmit={tempCartToSubmit}
        tempBookingDate={tempBookingDate}
        setTempCartToSubmit={setTempCartToSubmit}
        setTempBookingDate={setTempBookingDate}
      />
    </>
  );
};

export default PickUpSummary;
